import classNames from 'classnames/bind';
import { useContext } from 'react';
import { Modal, ModalFuncContext, ModalPosition } from 'contexts/modalFunc';
import { City, DepartureDate, Direct, Passenger, Swap } from '../select';
import styles from './index.module.scss';
import { ITabContent } from '..';

const cx = classNames.bind(styles);

export default function OneWay({ clickCodePrefix }: ITabContent) {
  const setModal = useContext(ModalFuncContext);
  const modalHandler = (type: Modal) => () =>
    setModal({ type, position: ModalPosition.MAIN });

  return (
    <>
      <div className={cx('routes')}>
        <City
          className={cx('route')}
          departure
          index={0}
          clickCodePrefix={clickCodePrefix}
          onClick={modalHandler(Modal.DEPARTURES)} // [D] 모든곳 검색인 경우 - modalHandler(Modal.DEPARTURES_EVERYWHERE)
        />
        <City
          className={cx('route')}
          index={0}
          clickCodePrefix={clickCodePrefix}
          onClick={modalHandler(Modal.ARRIVALS)}
        />
        <Swap
          className={cx('swap')}
          index={0}
          clickCodePrefix={clickCodePrefix}
        />
      </div>
      <div className={cx('options')}>
        <DepartureDate
          className={cx('option')}
          index={0}
          clickCodePrefix={clickCodePrefix}
          onClick={modalHandler(Modal.CALENDAR)}
        />
      </div>
      <div className={cx('options')}>
        <Passenger className={cx('option')} clickCodePrefix={clickCodePrefix} />
        <Direct
          className={cx('option', 'as_direct')}
          clickCodePrefix={clickCodePrefix}
        />
      </div>
    </>
  );
}
